import TitleCR from './TitleCR'

export default TitleCR
